export default "__VITE_ASSET__CC7GKFgm__"